import React, { useEffect, useRef, useState } from "react";
import { NumbersContainer, TimelineContainer, ContentLeft, ContentRight, ImageContainer, ImageSection } from './VerticalTimeline.style'
import One from '../../assets/Timeline/One.png'
import Two from '../../assets/Timeline/Two.png'
import Three from '../../assets/Timeline/Three.png'
import BackgroundAbout from '../../assets/Timeline/background-about.png'

const useIntersectionObserver = (options) => {
  const [isVisible, setIsVisible] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      setIsVisible(entry.isIntersecting);
    }, options);

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => {
      if (ref.current) {
        observer.unobserve(ref.current);
      }
    };
  }, [options]);

  return [ref, isVisible];
};

const VerticalTimeline = () => {
  const [timelineRef1, isVisible1] = useIntersectionObserver({ threshold: 0.2 });
  const [timelineRef2, isVisible2] = useIntersectionObserver({ threshold: 0.2 });
  const [timelineRef3, isVisible3] = useIntersectionObserver({ threshold: 0.2 });
    return(
          <TimelineContainer>
            <NumbersContainer ref={timelineRef1} style={{
              opacity: isVisible1 ? 1 : 0,
              transform: isVisible1 ? "translateY(0)" : "translateY(50px)",
              transition: "opacity 0.8s ease-out, transform 0.8s ease-out"
            }}>
              <ContentLeft number='1' style={{
                transform: isVisible1 ? "translateX(0)" : "translateX(-100%)",
                transition: "transform 0.8s ease-out 0.2s"
              }}>
                <ImageContainer size='60%'>
                  <img src={One} alt='One' />
                </ImageContainer>
              </ContentLeft>
              <ContentRight style={{
                transform: isVisible1 ? "translateX(0)" : "translateX(100%)",
                transition: "transform 0.8s ease-out 0.4s"
              }}>
                <h2>Medicamentos Genéricos</h2>
                <p>Enfoque de salud que combina lo medicina convencional con terapias complementarias y alternativas, buscando tratar a la persona de manera holística. Su objetivo es integrar el cuerpo y mente  reconociendo que la salud no solo depende de la ausencia de enfermedad, sino también del bienestar emocional, social y espiritual.</p>
              </ContentRight>
            </NumbersContainer>
            <NumbersContainer ref={timelineRef2} style={{
              opacity: isVisible2 ? 1 : 0,
              transform: isVisible2 ? "translateY(0)" : "translateY(50px)",
              transition: "opacity 0.8s ease-out, transform 0.8s ease-out"
            }}>
              <ContentLeft number='2' style={{
                transform: isVisible2 ? "translateX(0)" : "translateX(-100%)",
                transition: "transform 0.8s ease-out 0.2s"
              }}>
                <ImageContainer size='80%'>
                  <img src={Two} alt='Two' />
                </ImageContainer>
              </ContentLeft>
              <ContentRight style={{
                transform: isVisible2 ? "translateX(0)" : "translateX(100%)",
                transition: "transform 0.8s ease-out 0.4s"
              }}>
                <h2>Medicina Estética</h2>
                <p>Eupha Beauty se centra en tener productos de alta calidad y de reconocimiento mundial que brindan no solamente resultados efectivos y comprobables sino que una forma segura, profesional y sofisticada de integrar la medicina con lo estético.</p>
              </ContentRight>
            </NumbersContainer>
            <NumbersContainer ref={timelineRef3} style={{
              opacity: isVisible3 ? 1 : 0,
              transform: isVisible3 ? "translateY(0)" : "translateY(50px)",
              transition: "opacity 0.8s ease-out, transform 0.8s ease-out"
            }}>
              <ContentLeft number='3' style={{
                transform: isVisible3 ? "translateX(0)" : "translateX(-100%)",
                transition: "transform 0.8s ease-out 0.2s"
              }}>
                <ImageContainer size='60%'>
                  <img src={Three} alt='Three' />
                </ImageContainer>
              </ContentLeft>
              <ContentRight style={{
                transform: isVisible3 ? "translateX(0)" : "translateX(100%)",
                transition: "transform 0.8s ease-out 0.4s"
              }}>
                <h2>Medicina Integrativa</h2>
                <p>Nos sentimos comprometidos con la enseñanza, divulgación, reconocimiento y práctica de las distintas opciones terapéuticas que representamos, con el objetivo de brindar estar constantemente actualizados con el medio de la medicina integrativa y ponerlo al servicio de los profesionales de la salud y que estos puedan ponerlo en practica a beneficio directo para el paciente.</p>
              </ContentRight>
            </NumbersContainer>
          </TimelineContainer>
    )
}

export default VerticalTimeline
